import * as React from 'react';
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Input, Checkbox, TextArea } from '@progress/kendo-react-inputs';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { FloatingLabel } from '@progress/kendo-react-labels';
import { Button, Chip } from '@progress/kendo-react-buttons';

export default function ContactsDetailsComponents() {
    const { t } = useTranslation();

    const [integrador, setIntegrador] = React.useState('');
    const [activo, setActivo] = React.useState('');

    const Integradores = [
        'Baseball',
        'Basketball',
        'Volleyball'
    ];

    const fruits = [
        { text: "Berry", value: "berry" },
        { text: "Apple", value: "apple" },
        { text: "Strawberry", value: "strawberry" },
        { text: "Banana", value: "banana" },
        { text: "Kiwi", value: "kiwi" },
        { text: "Banana123", value: "banana312312" },
        { text: "Kiwi312", value: "kiwi123" },
        { text: "Banana3123", value: "banana3123" },
        { text: "Kiwi312", value: "kiwi312" },
        { text: "Banasdsana123", value: "banandasda312312" },
        { text: "Kiwi312dasd", value: "kiwi1das23" },
        { text: "Banana312asd3", value: "banasdasana3123" },
        { text: "Kiwi312dasd", value: "dasdkiwi312" },
    ];

    const [selectedFruit, setSelectedFruit] = useState(null);
    const [selectedFruits, setSelectedFruits] = useState([]);

    const handleAddFruit = (value) => {
        const fruitObj = fruits.find((f) => f.value === value);
        if (fruitObj && !selectedFruits.some((f) => f.value === value)) {
            setSelectedFruits([...selectedFruits, fruitObj]);
        }
    };

    const handleRemoveFruit = (removedValue) => {
        setSelectedFruits(selectedFruits.filter((f) => f.value !== removedValue));
    };

    return (
        <div>

            <div className="container-fluid">
                <div className="col-12 col-lg-11 mx-auto">
                    <div className="card">
                        <div className="card-body bg-light py-3">
                            <h5 className="card-title m-0">{t("Global_Label_Text_General")}</h5>
                        </div>

                        <div className="container p-4">
                            <div className="row">
                                {/* Columna 1 */}
                                <div className="col-12 col-md-4">
                                    <div className="mb-3">
                                        <Input
                                            label={t("Global_Label_Text_Name")}
                                            style={{ width: "70%" }}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <Input label={t("Global_Label_Text_NIF")}
                                            style={{ width: "70%" }}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <Input label={t("Global_Label_Text_Address")}
                                            style={{ width: "70%" }}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <Input label={t("Global_Label_Text_City")}
                                            style={{ width: "70%" }}
                                        />
                                    </div>
                                </div>

                                {/* Columna 2 */}
                                <div className="col-12 col-md-4">
                                    <div className="mb-3">
                                        <Input label={t("Global_Label_Text_Zip_Code")}
                                            style={{ width: "70%" }}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <Input label={t("Global_Label_Text_Phone")}
                                            style={{ width: "70%" }}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <Input label={t("Global_Label_Text_Mobile_Phone")}
                                            style={{ width: "70%" }}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <Input label={t("Global_Label_Text_Email")}
                                            style={{ width: "70%" }}
                                        />
                                    </div>
                                </div>

                                {/* Columna 3 */}
                                <div className="col-12 col-md-4">
                                    <div className="mb-3">
                                        <FloatingLabel label={t("Global_Label_Text_Integrator")} editorId="integrador" editorValue={integrador}>
                                            <DropDownList
                                                id="integrador"
                                                data={Integradores}
                                                value={integrador}
                                                onChange={(e) => setIntegrador(e.target.value)}
                                            />
                                        </FloatingLabel>
                                    </div>
                                    <div className="mb-3">
                                        <FloatingLabel label={t("Global_Label_Text_Paper")} editorId="papel" editorValue={integrador}>
                                            <DropDownList
                                                id="papel"
                                                data={Integradores}
                                                value={integrador}
                                                onChange={(e) => setIntegrador(e.target.value)}
                                            />
                                        </FloatingLabel>
                                    </div>
                                    <div className="mb-3">
                                        <FloatingLabel label={t("Global_Label_Text_Default")}>
                                            <Checkbox
                                                defaultChecked={false}
                                                value={activo}
                                                onChange={(e) => setActivo(e.target.value)}
                                            />
                                        </FloatingLabel>
                                    </div>
                                    <div className="mb-3">
                                        <FloatingLabel label={t("Global_Label_Text_Messages")}>
                                            <Checkbox
                                                defaultChecked={false}
                                                value={activo}
                                                onChange={(e) => setActivo(e.target.value)}
                                            />
                                        </FloatingLabel>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid mt-4">
                <div className="col-12 col-lg-11 mx-auto">
                    <div className="card">
                        <div className="card-body bg-light py-3">
                            <h5 className="card-title m-0">{t("Global_Label_Text_Remarks")}</h5>
                        </div>

                        <div className="container p-3 p-md-4">
                            <div className="row g-3 mb-3 mb-md-4">
                                <TextArea
                                    label={t("Global_Label_Text_Remarks")}
                                    rows={4}
                                    style={{ width: "100%" }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid mt-4">
                <div className="col-12 col-lg-11 mx-auto">
                    <div className="card">
                        <div className="card-body bg-light py-3">
                            <h5 className="card-title m-0">{t("Global_Label_Text_User")}</h5>
                        </div>

                        <div className="container p-3 p-md-4">
                            <div className="d-flex justify-content-center">
                                <div className="row g-3 align-items-start w-100" style={{ maxWidth: "900px" }}>
                                    {/* DropDownList (Columna Izquierda) */}
                                    <div className="col-12 col-md-6">
                                        <FloatingLabel label={t("Global_Label_Text_Roles")} editorId="fruitSelect" editorValue={selectedFruit?.text || ""}>
                                            <DropDownList
                                                id="fruitSelect"
                                                data={fruits}
                                                textField="text"
                                                dataItemKey="value"
                                                value={selectedFruit}
                                                onChange={(e) => {
                                                    const value = e.target.value?.value;
                                                    setSelectedFruit(e.target.value);
                                                    handleAddFruit(value);
                                                }}
                                            />
                                        </FloatingLabel>
                                    </div>

                                    <div className="col-12">
                                        <div
                                            className="border rounded p-3 bg-light"
                                            style={{
                                                minHeight: '100px',
                                                maxHeight: '300px',
                                                overflowY: 'auto',
                                            }}
                                        >
                                            <h6 className="mb-3">{t("Global_Label_Text_Role_List")}</h6>

                                            {selectedFruits.length === 0 ? (
                                                <div className="text-muted">{t("Global_Label_Text_Empty_List")}</div>
                                            ) : (
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        flexWrap: 'wrap',
                                                        gap: '0.5rem',
                                                    }}
                                                >
                                                    {selectedFruits.map((f) => (
                                                        <Chip
                                                            key={f.value}
                                                            text={f.text}
                                                            value={f.value}
                                                            removable={true}
                                                            onRemove={() => handleRemoveFruit(f.value)}
                                                        />
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>





            <div className="container-fluid mt-4">
                <div className="col-12 col-lg-11 mx-auto">
                    <div className="d-flex justify-content-end mb-3">
                        <Button className="action-button me-lg-11">{t("Global_Label_Text_Save")}</Button>
                    </div>
                </div>
            </div>



        </div>


    );
}